import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateObject({ username, onObjectID, onClose, getObjects }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");


    let user2;
    try {
        user2 = JSON.parse(username);
    } catch (e) {
        user2 = username;
    }

    const [formData, setFormData] = useState({
        name: '',
        comment: '',
        user_transaction: user2,
        est_id: '',
        id: ''
    });

    useEffect(() => {
        const getObject = async () => {
            try {
                const response = await axios.get(`${server_backend}/objects/select?id=${onObjectID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        user_transaction: username,
                        est_id: data.est_ID,
                        id: onObjectID
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getObject();
    }, [onObjectID, username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/objects/update`, formData, headers);
            if (response.data.RES_CODE === "00") {
             
                Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
                onClose()
                getObjects()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'There is already a group with the same name, please try with another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade bs-example-modal-xl show azoomOutDown" tabIndex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-modal="true" style={{ display: "block", backgroundColor: "#0101019e" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myExtraLargeModalLabel">Modify Object</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="tab-pane fade show active" id="pills-bill-info" role="tabpanel" aria-labelledby="pills-bill-info-tab">
                            <div className="live-preview">
                                <form onSubmit={handleUpdate}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="name" className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your name"
                                                    id="name"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="comment" className="form-label">Comment</label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Enter comment"
                                                    id="comment"
                                                    name="comment"
                                                    value={formData.comment}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Transaction</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter user transaction"
                                                    id="user_transaction"
                                                    value={user2}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Status</label>
                                                <select
                                                    className="form-select"
                                                    aria-label=".form-select-sm example"
                                                    name="est_id"
                                                    value={formData.est_id}
                                                    onChange={handleChange}
                                                >
                                                    {formData.est_id === 1 ? (
                                                        <>
                                                            <option value="1">Activated</option>
                                                            <option value="2">Disabled</option>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <option value="2">Disabled</option>
                                                            <option value="1">Activated</option>
                                                        </>
                                                    )}

                                                </select>

                                            </div>
                                        </div>
                                        {/* User Info */}
                                        <h4 className='p-3'>Other information</h4>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Transaction</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={formData.user_transaction}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="date_created" className="form-label">Date Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={dateCreated}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="user_created" className="form-label">User Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={userCreated}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="date_modify" className="form-label">Date Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={dateModify}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="text-end">
                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    {loading ? 'Loading...' : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateObject;
